/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import RichTextFieldItemEdit from "./edit-item";

const RichTextFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <RichTextFieldItemEdit />
        </FieldListEditWrapper>
    );
};
RichTextFieldEdit.displayName = "RichTextFieldEdit";
export { RichTextFieldEdit };
